import React, { useEffect } from "react";

import './App.css';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
    useLocation,
    withRouter,
} from "react-router-dom";
//custom components
import ServerApi from '../../services/server-api-service';
import { AnimatePresence, motion } from 'framer-motion';
import Header from '../header';
import Footer from '../footer';
import HomePage from '../home-page';
import WizardPage from '../wizard-page';
import ListingPage from '../listing-page';
import NeighborhoodPage from '../neighborhood-page';
import AboutPage from '../about-page';
import OurTeamPage from '../our-team-page';
import ContactUsPage from '../contact-us-page';
import SellPage from '../sell-page';
import PrivacyPage from '../privacy-page';
import SelectionPage from '../selection-page';
import SelectionListingPage from '../selection-listing-page';
import Page404 from '../page404';
import SearchPage from '../search-page';
import ConstructionLobbyPage from '../construction-lobby-page';
import NeighborhoodsPage from '../neighborhoods-page';
import ProjectCompanyPage from "../project-company-page";
import ProjectCompanyMobilePage from "../project-company-mobile-page";
import FindMyDealModal from '../find-my-deal-modal';
import HeaderSelection from '../header-selection';
import ConstructionLobbyMenu from '../construction-lobby-menu';
import ListingGallery from "../listing-gallery/listing-gallery";
import ArticleInnerPage from '../article-inner-page';
import ProjectInnerPage from '../project-inner-page';
import CustomLandingPage from "../custom-landing-page";
import MiamiMovePage from "../custom-landing-pages/miami-move";
import ArticlesPage from '../articles-page';
import SelectionListingModal from '../selection-listing-modal';
import ShortRentalPage from '../short-rental-page';
import CookiesManager from '../../services/cookies-manager';
import Helmet from 'react-helmet';
import DocumentRedirectPage from "../document-redirect-page";
import StandAloneGalleryPage from "../stand-alone-gallery/stand-alone-gallery-page";
import LinkTreePage from "../link-tree-page/link-tree-page";
import SelectionProjectOfferPage from '../selection-project-offer-page';
// import Parser from 'html-react-parser';
import RouterMark from '../router-mark';
import ApplicationHistoryService from '../../services/application-history-service';
import ConfigurationService from "../../services/configuration-service";
import '../../elements/common.css';
import SelectionMap from "../selection-map/selection-map";
import Modal from "../modal";
import SignAgreement from "../sign-agreement";
import ScrollBlock from "../scroll-block";

// import ListingPageModal from '../listing-page-modal';
import CustomCampaignLogic from "../../layouts/logics/custom-campaign-logic";

class SmartLuxe extends React.PureComponent {
    cookiesManager = null;
    applicationHistoryService = new ApplicationHistoryService();
    serverApi = new ServerApi();
    configurationService = new ConfigurationService();
    constructor(props) {
        super(props)
        this.state = {
            isSSR: true,
            pageIsLoaded: false,
            dealIsVisible: false,
            flagClose: false,
            debug: false,
            hoveredMarkerId: null,
            mobileVerison: false,
            selectionListings: {},
            displayOnMobileSelectionMap: false,
            isVisibleCaruselModal: false,
            selectionListingModal: false,
            currentSlideSelection: '',
            currentProjectLogo: null,
            currentProjectLogoInvert: null,
            selectionDisplay: "flex",
            showSelectionMap: true,
            selectionHeader: false,
            showSelectionToolBar: false,
            mapSide: 'right',
            allowedLanguages: null,
            footerHideElem: false,
            isVisibleFooter: true,
            isVisibleHeader: true,
            selectionMapFloating: false,
            selectionMapSettings:{
                elementHeaderId: "HeaderMain",
                elementHeaderIdOffset: null,
                elementFooterId: "Footer",
                elementFooterIdOffset: '',
            },
            isEnablePopUps:true,
            currentSelectionListing: {},
            mapSecondaryMarkers: null,
            applicationHistory: [],
            heightRouterMark: '800px',
            widthRouterMark: 'auto',
            articlesTranslations: null,
            headerDisableMenu:false,
            agent: null,
            currentPage: '',
            routerMarkStyle:{},
            
            constructionLobbySearchForm: {
                neighbourhood: '',
                condo: false,
                singleFamilyHome: false,
                townhouse: false,
                shortTermApproved: false
            }
        }
        this.closeModal = this.closeModal.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }

    getDictionary() {
        this.serverApi.getDictionary()
            .then((data) => {
                if (this.state.debug) {
                    console.log('getDictionary data: ', data);
                }
                this.setState({
                    dictionary: data
                });

            })
            .catch((error) => {
                console.log(`ERROR: fetch getFeaturedNeighboorhoods ... -> Component: APP  ERROR:${error}`);
            })
    }


    getGeoInfo() {
        this.serverApi.getGeoIp()
            .then((data) => {
                if (this.state.debug) {
                    console.log('getGeoIp data:', data);
                }

                this.setState((prevState) => {
                    return {
                        geoipObj: data,
                        country: data.iso_code
                    }
                })

            })
            .catch((error) => {
                console.log(`ERROR: fetch getGeoIp ... -> Component: APP  ERROR:${error}`);
                  this.setState((prevState) => {
                    return {
                        geoipObj:{
                            country:null
                        } 
                    }
                })

            })
    }

    getNeighborhoods() {
        this.serverApi.getFeaturedNeighborhoods()
            .then((data) => {
                this.setState({
                    neighboorhoods: data
                })
            })
            .catch((error) => {
                console.log(`ERROR: fetch getFeaturedNeighboorhoods ... -> Component: APP  ERROR:${error}`);
            })
    }



    componentWillMount() {
        console.log('App mounted')
        this.configurationService.checkDomainName();
        // this.configurationService.checkLanguage(this.state.currentPage);
        this.getDictionary();
        this.getNeighborhoods();
        this.getGeoInfo();

    }

    componentDidMount() {
        this.getVersion()

        this.setState({
            isSSR: false
        })

        // this.configurationService.checkSubdomain();
        //get dictionary    
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('scroll', this.handleScroll);
        //  window.addEventListener("orientationchange", this.handleMobileOrientation, false);
        document.addEventListener('markerHover', this.handleMarkerHover);
        document.addEventListener('openModal', this.handleOpenModal);
        window.addEventListener('popstate', this.handleBackButton);

        if (window.innerWidth <= 775) {
            this.setState({
                width: window.innerWidth,
                height: window.innerHeight,
                mobileVerison: true,
            })
        } else {
            this.setState({
                width: window.innerWidth,
                height: window.innerHeight,
            })
        }

        this.cookiesManager = new CookiesManager();
        if (this.state.debug) {
            console.log("componentDidMount ... -> Component: App");
        }

        sessionStorage.setItem('referrer', document.referrer)
        let search = document.location.search;
        let params = {}
        if (    document.location.search.includes('gclid=') || document.location.search.includes('fbclid=') ||
                document.location.search.includes('wbraid=') || document.location.search.includes('utm_source=') ||
                document.location.search.includes('tbclid=') ) {
            const hashes = search.slice(search.indexOf('?') + 1).split('&')

            hashes.map(hash => {
                const [key, val] = hash.split('=')
                params[key] = decodeURIComponent(val)
                return null;
            })
        }
        if (params.gclid !== null) sessionStorage.setItem('GCLID', params.gclid)
        if (params.fbclid !== null) sessionStorage.setItem('FBCLID', params.fbclid)
        if (params.wbraid !== null) sessionStorage.setItem('WBRAID', params.wbraid)
        if (params.tbclid !== null) sessionStorage.setItem('TBCLID', params.tbclid)
        if (params.utm_source !== null) sessionStorage.setItem('referrer', params.utm_source+'.com')
        if (this.cookiesManager.get('exit_pop') === undefined || this.cookiesManager.get('exit_pop') !== '1') {
            setTimeout(() => {
                this.setState({
                    flagClose: true//true - open when try close
                })
            }, 6000)
        }
        // if(sessionStorage.getItem('flagExitModal')===null||sessionStorage.getItem('flagExitModal') !== 'false'){
        //     setTimeout(() => {
        //         this.setState({
        //             flagClose: true//true - open when try close
        //         })
        //     }, 100)
        // }
    }

    componentWillUpdate(prevProps,prevState) {
        if(this.state.currentPage !== prevState.currentPage){
            this.configurationService.checkLanguage(prevState.currentPage);
        }

        if (this.state.version && document.getElementById('version') && this.state.version != document.getElementById('version').content) {
            window.location.href = window.location.href
        }
        if ((document.location.pathname.includes('/selection') || document.location.pathname.includes('/projects'))
            && !(document.location.pathname.includes('/projects') && (document.location.pathname.includes('/article')))) {
            // scrollbar.overflow='none';
            document.body.classList.add('hidden-scrollbar');
        } else {
            document.body.classList.remove('hidden-scrollbar');
        }
        this.insertJSONLD();

        if (this.props.location !== prevProps.location) {
            this.applicationHistoryService.push(this.props.location);
        }
    }

    componentDidUpdate(prevProps, prevState) {

        if(this.state.currentPage !== prevState.currentPage){
            let subdomain = this.configurationService.getSubdomain();
            if(this.state.currentPage !== '' && subdomain) this.configurationService.checkSubdomainPage(this.state.currentPage);
        }
    }
    
    componentWillUnmount() {
        document.removeEventListener('markerHover', this.handleMarkerHover);
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('popstate', this.handleBackButton);
        document.removeEventListener('openModal', this.handleOpenModal);

    }

    getVersion = () => {
        this.serverApi.getVersion()
            .then((data) => {
                this.setState({
                    version: data.version
                })
            })
            .catch((error) => {
                console.log('Error with get verison: ', error)
            })
    }

    insertJSONLD() {
        let { dictionary } = this.state;
        //insert JSON-LD

        if (dictionary !== undefined && !document.location.pathname.includes('/listing')) {
            const metaData = `{
            "@context": "https://schema.org/",
            "@type": "Thing",
            "name": "Smart Luxe - ${dictionary.slogan}",
            "subjectOf": {
                "@type": "Site",
                "name": "Smart Luxe - ${dictionary.slogan}"
            }
        }`
            if (document.getElementById('productApplactionLd') !== null && document.getElementById('productApplactionLd').textContent !== metaData) {
                document.getElementById('productApplactionLd').remove();
            }


            const jsonldScript = document.createElement('script');
            jsonldScript.setAttribute('type', 'application/ld+json');
            jsonldScript.setAttribute('id', 'productApplactionLd');


            if (document.getElementById('productApplactionLd') === null) {
                jsonldScript.textContent = metaData;
                document.head.appendChild(jsonldScript);
            }
        }
    }

    handleBackButton = (event) => {
        if (this.applicationHistoryService.getLength() > 0 && event.state != null) {
            this.applicationHistoryService.pop();
            // this.applicationHistoryService.removeByKey(event.state.key)
        }
    }

    handleMarkerHover = (event) => {
        this.setState({
            hoveredMarkerId: event.detail.id
        })
    }

    handleMouseMove = (event) => {
        this.setState(() => {
            return {
                mouseEvent: event
            }
        })
        if (!this.state.isSSR && this.state.currentPage !='CustomLandingPage') {
            if (event.clientY < 5 && this.state.flagClose && (this.cookiesManager.get('exit_pop') === undefined || this.cookiesManager.get('exit_pop') !== '1') && this.state.isEnablePopUps) {
                this.setState({
                    dealIsVisible: true
                })
            }
        }

    }

    handleOpenModal = (event) => {
        this.setState((prevState) => {
            return {
                ...prevState,
                [event.detail.name]: event.detail.value,
                currentSlideSelection: event.detail.currentSlide
            }
        })
    }

    handleResize(event) {
        // let width = event.target.innerWidth;
        // let height = event.target.innerHeight;

        let width = window.innerWidth;
        let height = visualViewport.height;
        let mobileVerison = this.state.mobileVerison;

        if (width <= 775 && !mobileVerison) {
            if (this.state.debug) {
                console.log('Swithced to mobile version');

            }
            this.setState({
                ...this.state,
                width: width,
                height: height,
                mobileVerison: true
            })
        } else if (width > 775 && mobileVerison) {
            if (this.state.debug) {
                console.log('Swithced to desktop version');

            }
            this.setState({
                ...this.state,
                width: width,
                height: height,
                mobileVerison: false
            })
        } else {
            this.setState({
                ...this.state,
                height: height,
                width: width
            })
        }
    }

    handleScroll() {
        this.setState({
            pageScroll: window.pageYOffset
        })
    }

    handleInputForm = (formName, name, value) => {
        this.setState({
            ...this.state,
            [formName]: {
                ...this.state[formName],
                [name]: value
            }
        }, () => {
            if (formName === 'constructionLobbySearchForm') {
                window.dispatchEvent(new CustomEvent('getProjectsList', {}))
            }
        })
    }

    closeModal = () => {
        if (!this.state.isSSR) {
            if (this.cookiesManager.get('exit_pop') == null) {
                this.cookiesManager.set('exit_pop', 1, 30)
            }
            this.setState({
                dealIsVisible: false,
                flagClose: false,
            })
        }
    }

    saveSelectionListings = (data, selectionId, agentId = null) => {
        this.setState({
            dataForMap: data,
            selectionId: selectionId,
            agentId: agentId
        })
        if (!this.state.isSSR) {
            if (this.cookiesManager.get(selectionId)) {
                let listingExpiredList = JSON.parse(this.cookiesManager.get(selectionId))
                if (listingExpiredList) {
                    this.setState({
                        listingExpiredList: listingExpiredList
                    })
                }
            }
        }
    }

    saveCurrentSelectionListing = (data) => {
        this.setState({
            currentSelectionListing: data
        })
    }

    setSliderModal = (value) => {
        this.setState({
            isVisibleSliderModal: value
        })
    }

    saveDataForMap = (data, pageInfo) => {
        this.setState({
            dataForMap: data
        })
    }

    saveState = (obj) => {
        if (obj) {
            this.setState((prevSate) => {
                return obj;
            })
        }
    }



    // saveState = (stateName, value) => {
    //     this.setState((prevSate) => {
    //         return {
    //             [stateName]: value
    //         }
    //     })
    // }

    renderBody() {
        if (this.state.dictionary !== undefined && this.state.neighboorhoods) {
            let { currentSlideSelection, selectionListingModal, isVisibleSliderModal,
                agentId, dictionary, dataForMap, neighboorhoods,
                mobileVerison, width, height,
                currentSelectionListing, selectionId, listingExpiredList, hoveredMarkerId,
                currentProjectLogo, isVisibleFooter, selectionMapFloating, selectionMapSettings, allowedLanguages, mapSecondaryMarkers,
                constructionLobbySearchForm, selectionDisplay, showSelectionToolBar, mapSide, selectionHeader,
                mapSoldOutMarkers, currentProjectLogoInvert, footerHideElem, currentPage, agent, pageScroll, mouseEvent, articlesTranslations,
                isVisibleHeader,headerDisableMenu, geoipObj, country, displayOnMobileSelectionMap
            } = this.state;
            let { location, history } = this.props;

            let subdomain = this.configurationService.getSubdomain();
            const pageTransition = {
                in: {
                    opacity: 1
                },
                out: {
                    opacity: 0
                }
            }
            let pathname = document.location.pathname;
            let search = document.location.search;
            let hostname = document.location.hostname;
            let protocol = document.location.protocol;
            let port = document.location.port;

            const supportedLanguages = ['es', 'pt', 'en', 'he']; // need to refactor to get from config file.

            const langPattern = supportedLanguages.join('|');
            const withLang = (paths) => {
                const normalize = (path) => {
                    const safePath = path.startsWith('/') ? path : `/${path}`;
                    if (safePath === '/') return `/:lang(${langPattern})`;
                    return `/:lang(${langPattern})${safePath}`;
                };

                return Array.isArray(paths) ? paths.map(normalize) : normalize(paths);
            };

            const routeGroups = {
                public: {
                    home: withLang('/'),
                    listingGallery: withLang('/listing/:id/gallery'),
                    findMyDeal: withLang(['/find-my-deal', '/neighborhood/:id/:name/find-my-deal']),
                    listing: withLang(['/listing/:id/:agentId', '/listing/:id']),
                    neighborhood: withLang(['/neighborhood/:id/:name', '/neighborhood/:id']),
                    neighborhoods: withLang('/neighborhoods'),
                    about: withLang('/about'),
                    team: withLang('/team'),
                    contact: withLang('/contact'),
                    sell: withLang('/sell'),
                    privacy: withLang('/privacy'),
                    linkTree: withLang('/l/:instagram'),
                    pageNotFound: withLang('/page-not-found'),
                    search: withLang('/Search'),
                    shortTermRental: withLang('/short_term_rental'),
                    investMiamiCampaign: withLang('/campaigns/investmiami'),
                    moveMiamiCampaign: withLang('/campaigns/movemiami/'),
                    agreement: withLang('/agreement/sign/:agreementId'),
                    document: withLang('/doc/:id')
                },
                content: {
                    articleInner: withLang(['/projects/:projectId/:projectName/articles/:id/:articleName', '/articles/:id/:articleName']),
                    articles: withLang('/articles'),
                    pageNotFound: withLang('/page-not-found'),
                    mobileCampaign: withLang('/project/:id/mobile-campaign/:name'),
                    projectCampaignOrHome: withLang(['/project/:id/campaign/:name', '/']),
                    fallback: withLang('/*')
                },
                selection: {
                    projectGallery: withLang('/projects/:projectId/:projectName/gallery'),
                    projectInner: withLang('/projects/:id/:name'),
                    projects: withLang(['/projects/:id', '/projects']),
                    selectionListing: withLang(['/selection/:selectionId/:agentId/listing/:listingId', '/selection/:selectionId/listing/:listingId']),
                    selectionOffer: withLang(['/selection/:selectionId/:agentId/offer/:offerId', '/selection/:selectionId/offer/:offerId']),
                    selection: withLang(['/selection/:selectionId/:agentId', '/selection/:selectionId'])
                }
            };

            const getNormalizedLangRedirect = (currentPathname, currentSearch) => {
                const collapsedSlashesPath = currentPathname.replace(/\/+/g, '/');
                if (collapsedSlashesPath !== currentPathname) {
                    return `${collapsedSlashesPath}${currentSearch}`;
                }

                const langPrefixMatch = currentPathname.match(/^\/([a-z]{2})(?=\/|$)/i);

                if (!langPrefixMatch) {
                    if (currentPathname === '/' || currentPathname === '') return `/en${currentSearch}`;
                    return `/en${currentPathname}${currentSearch}`;
                }

                const currentLang = langPrefixMatch[1].toLowerCase();
                if (supportedLanguages.includes(currentLang)) return null;

                const pathWithoutInvalidLang = currentPathname.replace(/^\/[a-z]{2}(?=\/|$)/i, '') || '/';
                if (pathWithoutInvalidLang === '/') return `/en${currentSearch}`;
                return `/en${pathWithoutInvalidLang}${currentSearch}`;
            };

            const getLegacySubdomainRedirectUrl = (currentHostname, currentPathname, currentSearch) => {
                const subdomainLangMatch = currentHostname.match(/^([a-z]{2})\./i);
                if (!subdomainLangMatch) return null;

                const subdomainLang = subdomainLangMatch[1].toLowerCase();
                if (!supportedLanguages.includes(subdomainLang)) return null;

                const canonicalHostname = currentHostname.replace(/^([a-z]{2})\./i, '');
                const hostWithPort = port ? `${canonicalHostname}:${port}` : canonicalHostname;

                const langInPathMatch = currentPathname.match(/^\/([a-z]{2})(?=\/|$)/i);
                let canonicalPath = currentPathname;

                if (langInPathMatch) {
                    const pathLang = langInPathMatch[1].toLowerCase();
                    if (supportedLanguages.includes(pathLang)) {
                        canonicalPath = currentPathname;
                    } else {
                        const strippedPath = currentPathname.replace(/^\/[a-z]{2}(?=\/|$)/i, '') || '/';
                        canonicalPath = strippedPath === '/' ? `/${subdomainLang}` : `/${subdomainLang}${strippedPath}`;
                    }
                } else {
                    canonicalPath = currentPathname === '/' || currentPathname === ''
                        ? `/${subdomainLang}`
                        : `/${subdomainLang}${currentPathname}`;
                }

                return `${protocol}//${hostWithPort}${canonicalPath}${currentSearch}`;
            };

            const legacySubdomainRedirectUrl = getLegacySubdomainRedirectUrl(hostname, pathname, search);
            if (legacySubdomainRedirectUrl !== null) {
                window.location.replace(legacySubdomainRedirectUrl);
                return null;
            }

            const langRedirectPath = getNormalizedLangRedirect(pathname, search);
            if (langRedirectPath !== null) {
                return <Redirect to={langRedirectPath} />;
            }


            if (!pathname.includes('/selection') && (!pathname.includes('/project'))
                && !pathname.includes('/articles') && !subdomain) {

                return (

                    <div onMouseMove={this.handleMouseMove.bind(this)} id="smartluxe">
                        {/* META TAGS */}
                        {
                            <Helmet>
                                <title>Smart Luxe - {dictionary.slogan}</title>
                                <meta name="description" content={dictionary.deal_finder_desc} />
                            </Helmet>
                        }

                        {/* META TAGS */}
                        {isVisibleHeader && <Header
                            width={width}
                            saveState={this.saveState}
                            neighboorhoods={neighboorhoods}
                            dictionary={this.state.dictionary}
                            pageScroll={this.state.pageScroll}
                            allowedLanguages={allowedLanguages}
                            articlesTranslations={articlesTranslations}
                            disableMenu={headerDisableMenu}
                            currentPage={currentPage}
                        />}

                        <Switch location={location} key={location.pathname}>

                            <Route exact path={routeGroups.public.home}>
                                <ScrollBlock>
                                   <HomePage
                                        neighboorhoods={neighboorhoods}
                                        mobileVerison={mobileVerison}
                                        width={width}
                                        dictionary={this.state.dictionary}
                                        saveState={this.saveState}
                                        hoveredMarkerId={hoveredMarkerId}
                                    />
                                  
                                </ScrollBlock>
                            </Route>

                            <Route path={routeGroups.public.listingGallery}>
                                <ScrollBlock>
                                        <ListingGallery
                                            width={width}
                                            dictionary={this.state.dictionary}
                                            height={height}
                                            saveState={this.saveState}
                                        />
                                   </ScrollBlock>
                            </Route>
                            <Route path={routeGroups.public.findMyDeal}>
                                <ScrollBlock>
                                        <WizardPage
                                            dictionary={this.state.dictionary}
                                            width={this.state.width}
                                            mobileVerison={mobileVerison}
                                            country={country}
                                            saveState={this.saveState}
                                        />
                                   </ScrollBlock>
                            </Route>
                            <Route path={routeGroups.public.listing}>
                                <ScrollBlock>
                                        <ListingPage
                                            width={width}
                                            dictionary={this.state.dictionary}
                                            height={height}
                                            country={country}
                                            saveState={this.saveState}
                                        />
                                    </ScrollBlock>
                            </Route>

                           

                            <Route path={routeGroups.public.neighborhood}>
                                <ScrollBlock>
                                        <NeighborhoodPage
                                            dictionary={this.state.dictionary}
                                            width={width}
                                            country={country}
                                            saveState={this.saveState}
                                            hoveredMarkerId={hoveredMarkerId}
                                        />
                                </ScrollBlock>
                            </Route>
                            <Route path={routeGroups.public.neighborhoods}>
                                <ScrollBlock>
                                        <NeighborhoodsPage
                                            dictionary={this.state.dictionary}
                                            width={width}
                                            neighboorhoods={neighboorhoods}
                                            country={country}
                                            saveState={this.saveState}
                                        />
                                </ScrollBlock>
                            </Route>
                            <Route path={routeGroups.public.about}>
                                <ScrollBlock>
                                        <AboutPage
                                            dictionary={this.state.dictionary}
                                            country={country}
                                            saveState={this.saveState}
                                        />
                                </ScrollBlock>
                            </Route>
                            <Route path={routeGroups.public.team}>
                                <ScrollBlock>
                                        <OurTeamPage
                                            dictionary={this.state.dictionary}
                                            country={country}
                                            saveState={this.saveState}
                                        />
                                   </ScrollBlock>
                            </Route>
                            <Route path={routeGroups.public.contact}>
                                <ScrollBlock>
                                        <ContactUsPage
                                            dictionary={this.state.dictionary}
                                            country={country}
                                            saveState={this.saveState}
                                        />
                                </ScrollBlock>
                            </Route>

                            <Route path={routeGroups.public.sell}>
                                <ScrollBlock>
                                        <SellPage
                                            dictionary={this.state.dictionary}
                                            country={country}
                                            width={width}
                                            saveState={this.saveState}
                                        />
                                     </ScrollBlock>
                            </Route>

                            <Route path={routeGroups.public.privacy}>
                                <ScrollBlock>
                                        <PrivacyPage
                                            dictionary={this.state.dictionary}
                                            country={country}
                                            saveState={this.saveState}
                                        />
                                </ScrollBlock>
                            </Route>

                            <Route path={routeGroups.public.linkTree}>
                                <ScrollBlock>
                                        <LinkTreePage
                                            dictionary={this.state.dictionary}
                                            country={country}
                                            saveState={this.saveState}
                                            width={width}
                                        />
                                </ScrollBlock>
                            </Route>

                            <Route path={routeGroups.public.pageNotFound}>
                                <ScrollBlock>
                                        <Page404
                                            dictionary={this.state.dictionary}
                                            country={country}
                                            saveState={this.saveState}
                                        />
                                </ScrollBlock>
                            </Route>



                            <Route path={routeGroups.public.search}>
                                <ScrollBlock>
                                        <SearchPage
                                            dictionary={this.state.dictionary}
                                            width={this.state.width}
                                            country={country}
                                            hoveredMarkerId={hoveredMarkerId}
                                            saveState={this.saveState}
                                        />
                                </ScrollBlock>
                            </Route>

                            <Route path={routeGroups.public.shortTermRental}>
                                <ScrollBlock>
                                        <ShortRentalPage
                                            dictionary={this.state.dictionary}
                                            width={this.state.width}
                                            country={country}
                                            hoveredMarkerId={hoveredMarkerId}
                                            saveState={this.saveState}
                                            neighboorhoods={neighboorhoods}
                                        />
                                </ScrollBlock>
                            </Route>
                            <Route path={routeGroups.public.investMiamiCampaign}>
                                <ScrollBlock>
                                   
                                        <CustomLandingPage
                                            dictionary={this.state.dictionary}
                                            width={this.state.width}
                                            country={country}
                                            saveState={this.saveState}
                                            neighboorhoods={neighboorhoods}
                                        />
                                </ScrollBlock>
                            </Route>

                              <Route path={routeGroups.public.moveMiamiCampaign}>
                                <ScrollBlock>
                                   
                                        <MiamiMovePage
                                            dictionary={this.state.dictionary}
                                            width={this.state.width}
                                            country={country}
                                            saveState={this.saveState}
                                            neighboorhoods={neighboorhoods}
                                            mobileVerison={mobileVerison}
                                        />
                                </ScrollBlock>
                            </Route>

                            <Route path={routeGroups.public.agreement}>
                                <ScrollBlock>
                                                <SignAgreement
                                                    pageScroll={pageScroll}
                                                    mobileVerison={mobileVerison}
                                                    dictionary={this.state.dictionary}
                                                    width={this.state.width}
                                                    country={country}
                                                    saveState={this.saveState}
                                                />
                                </ScrollBlock>
                            </Route>

                            <Route path={routeGroups.public.document}>
                                <ScrollBlock>
                                        <DocumentRedirectPage
                                            dictionary={this.state.dictionary}
                                            width={this.state.width}
                                            saveState={this.saveState}
                                        />
                                </ScrollBlock>
                            </Route>

                     

                            {/* <Redirect to="/page-not-found"></Redirect> */}
                        </Switch>
                        {isVisibleFooter && <Footer
                            dictionary={this.state.dictionary}
                            neighboorhoods={neighboorhoods}
                            hideElems={footerHideElem}
                             currentPage={currentPage}
                             width={width}
                        />}

                        <FindMyDealModal
                            isVisible={this.state.dealIsVisible} //this.state.dealIsVisible
                            country={country}
                            //isVisible={true}
                            closeModal={this.closeModal}
                            dictionary={this.state.dictionary}
                            location={location}
                        />
                    </div>
                )
            } else if (pathname.includes('project/') || pathname.includes('articles') || subdomain) {
                //selection section 
                // let { showSelectionMap, selectionHeader, mapSide, showSelectionToolBar,
                //     currentProjectLogoInvert, selectionDisplay, footerHideElem,
                //     leftBlockWidth, mapSoldOutMarkers,pageScroll } = this.state;


                let itemsAling = 'center';
                if (selectionMapFloating) {
                    itemsAling = 'flex-end'
                }

                let selectionStyle = {
                    display: selectionDisplay,
                    flexDirection: 'row',
                    justifyContent: itemsAling
                }

                if (mapSide != "left") {
                    selectionStyle = {
                        flexDirection: 'row-reverse',
                        display: selectionDisplay,
                        justifyContent: itemsAling,
                    }
                }

             
                //mapSide == "left" ? ({ flexDirection: 'row', justifyContent: itemsAling }) : ({ flexDirection: 'row-reverse', justifyContent: itemsAling })

                let flagLeftMap = false; // also it's mean that page projects (for markers) 
                let showHeader = pathname.includes('project');
                if (pathname.includes('/campaign') ) showHeader = false;
                if (pathname.includes('project') && !pathname.includes('/article') && pathname.includes('/campaign') ) flagLeftMap = false;
                return (
                    <div onMouseMove={this.handleMouseMove.bind(this)} id="smartluxe" >
                        {!selectionHeader ? (
                            <Header
                            width={width}
                                saveState={this.saveState}
                                neighboorhoods={neighboorhoods}
                                dictionary={this.state.dictionary}
                                pageScroll={this.state.pageScroll}
                                articlesTranslations={articlesTranslations}
                                allowedLanguages={allowedLanguages}
                                disableMenu={headerDisableMenu}
                                currentPage={currentPage}
                            />
                        ) : (
                            <HeaderSelection
                                saveState={this.saveState}
                                pageIsLoaded={this.state.pageIsLoaded}
                                width={width}
                                dictionary={dictionary}
                                selectionId={selectionId}
                                currentSelectionListing={currentSelectionListing}
                                agentId={agentId}
                                currentProjectLogo={currentProjectLogo}
                                allowedLanguages={allowedLanguages}
                            />
                        )}



                        {!showSelectionToolBar ? (null) : (
                            <ConstructionLobbyMenu
                                applicationHistoryService={this.applicationHistoryService}
                                neighboorhoods={neighboorhoods}
                                projectPage={showHeader}
                                dictionary={dictionary}
                                width={this.state.width}
                                currentSelectionListing={currentSelectionListing}
                                form={constructionLobbySearchForm}
                                handleInputForm={this.handleInputForm}
                            />
                        )}
                        <div className='Selection' style={selectionStyle}>
                            {!pathname.includes('/article') && !pathname.includes('/campaign')  && !isVisibleSliderModal ? (
                                <SelectionMap
                                    height={height}
                                    dictionary={dictionary}
                                    width={this.state.width}
                                    listings={dataForMap}
                                    currentSelectionListing={currentSelectionListing}
                                    selectionId={selectionId}
                                    agentId={agentId}
                                    listingExpiredList={listingExpiredList}
                                    markersWithModal={!flagLeftMap}
                                    hoveredMarkerId={hoveredMarkerId}
                                    selectionMapFloating={selectionMapFloating}
                                    selectionMapSettings={selectionMapSettings}
                                    saveCurrentSelectionListing={this.saveCurrentSelectionListing}
                                    mapSecondaryMarkers={mapSecondaryMarkers}
                                    mapSoldOutMarkers={mapSoldOutMarkers}
                                    currentPage={currentPage}
                                    mapSide={mapSide}

                                />
                            ) : null}
                            <Switch location={location} key={location.pathname}>

                                <Route path={routeGroups.content.articleInner}>
                                    <ScrollBlock>
                                            <ArticleInnerPage
                                                pageScroll={pageScroll}
                                                mobileVerison={mobileVerison}
                                                neighborhoods={neighboorhoods}
                                                dictionary={this.state.dictionary}
                                                width={this.state.width}
                                                country={country}
                                                saveState={this.saveState}
                                            />
                                            <FindMyDealModal
                                                isVisible={this.state.dealIsVisible} //this.state.dealIsVisible
                                                country={country}
                                                //isVisible={true}
                                                closeModal={this.closeModal}
                                                dictionary={this.state.dictionary}
                                                location={location}
                                            />
                                       
                                    </ScrollBlock>
                                </Route>

                                <Route path={routeGroups.content.articles}>
                                    <ScrollBlock>
                                            <ArticlesPage
                                                neighborhoods={neighboorhoods}
                                                dictionary={this.state.dictionary}
                                                width={this.state.width}
                                                country={country}
                                                saveState={this.saveState}
                                            />
                                           
                                    </ScrollBlock>
                                </Route>

                                {/* domain name */}
                                <Route path={routeGroups.content.pageNotFound}>
                                    <ScrollBlock>
                                            <Page404
                                                dictionary={this.state.dictionary}
                                                country={country}
                                                saveState={this.saveState}
                                            />
                                    </ScrollBlock>
                                </Route>


                             

                                <Route path={routeGroups.content.mobileCampaign}>
                                    <ScrollBlock>
                                            <ProjectCompanyMobilePage
                                                dictionary={this.state.dictionary}
                                                width={this.state.width}
                                                country={country}
                                                saveState={this.saveState}
                                                height={height}
                                            />
                                    </ScrollBlock>
                                </Route>

                                <Route path={routeGroups.content.articleInner}>
                                    <ScrollBlock>
                                            <ArticleInnerPage
                                                pageScroll={pageScroll}
                                                mobileVerison={mobileVerison}
                                                neighborhoods={neighboorhoods}
                                                dictionary={this.state.dictionary}
                                                width={this.state.width}
                                                country={country}
                                                saveState={this.saveState}
                                            />
                                            <FindMyDealModal
                                                isVisible={this.state.dealIsVisible} //this.state.dealIsVisible
                                                country={country}
                                                //isVisible={true}
                                                closeModal={this.closeModal}
                                                dictionary={this.state.dictionary}
                                                location={location}
                                            />
                                       
                                    </ScrollBlock>
                                </Route>




                                <Route path={"/:lang/articles"}>
                                    <ScrollBlock>
                                            <ArticlesPage
                                                neighborhoods={neighboorhoods}
                                                dictionary={this.state.dictionary}
                                                width={this.state.width}
                                                country={country}
                                                saveState={this.saveState}
                                            />
                                           
                                    </ScrollBlock>

                                </Route>

                                <Route exact path={routeGroups.content.projectCampaignOrHome}>
                                    <ScrollBlock>
                                            <ProjectCompanyPage
                                                mouseEvent={mouseEvent}
                                                dictionary={this.state.dictionary}
                                                width={this.state.width}
                                                country={country}
                                                geoipObj={geoipObj}
                                                saveState={this.saveState}
                                                pageScroll={this.state.pageScroll}
                                                mobileVerison={mobileVerison}
                                                height={height}
                                            />  
                                    </ScrollBlock>
                                </Route>

                                  {/* <Route exact path={["/campaigns/:campaignName/:lang"]}>
                                    <ScrollBlock>
                                        <CustomCampaignLogic>
                                            <CustomCampaignPage
                                                mouseEvent={mouseEvent}
                                                dictionary={this.state.dictionary}
                                                width={this.state.width}
                                                country={country}
                                                geoipObj={geoipObj}
                                                saveState={this.saveState}
                                                pageScroll={this.state.pageScroll}
                                                mobileVerison={mobileVerison}
                                                height={height}
                                            />
                                        </CustomCampaignLogic>
                                    </ScrollBlock>
                                </Route> */}

                                <Route path={routeGroups.content.fallback}>
                                    <ScrollBlock>
                                           <Page404
                                            dictionary={this.state.dictionary}
                                            country={country}
                                            saveState={this.saveState}
                                        />
                                    </ScrollBlock>
                                </Route>


                            </Switch>


                                    
                        </div>
                        {isVisibleFooter && <Footer
                            dictionary={this.state.dictionary}
                            neighboorhoods={neighboorhoods}
                            currentProjectLogoInvert={currentProjectLogoInvert}
                            hideElems={footerHideElem}
                            currentPage={currentPage}
                            width={width}
                        />}

                    </div>

                )
            } else if (pathname.includes('projects') || pathname.includes('selection/')) {
                let { selectionHeader, mapSide, showSelectionToolBar, isVisibleHeader,
                    currentProjectLogoInvert, selectionDisplay, footerHideElem,
                    mapSoldOutMarkers, widthRouterMark, pageScroll, heightRouterMark, currentPage, width,routerMarkStyle,headerDisableMenu} = this.state;

                let itemsAling = 'center';
                if (selectionMapFloating) {
                    itemsAling = 'flex-end'
                }

                let selectionStyle = {
                    display: selectionDisplay,
                    flexDirection: 'row',
                    justifyContent: itemsAling
                }

                if(displayOnMobileSelectionMap && width < 1200){
                    selectionStyle = {
                        flexDirection: 'column-reverse',
                        display: selectionDisplay,
                    }
                }else 

                if (mapSide != "left") {
                    selectionStyle = {
                        flexDirection: 'row-reverse',
                        display: selectionDisplay,
                        justifyContent: itemsAling,
                        paddingTop: !showSelectionToolBar && isVisibleHeader ? "130px" : '' //for disable LobbyMenuLine
                    }
                    // if(showSelectionToolBar) selectionStyle.paddingTop = '130px'
                    if (width < 1000) {
                        selectionStyle = {
                            position: 'relative',
                            flexDirection: 'row-reverse',
                            display: selectionDisplay,
                            justifyContent: itemsAling,
                            paddingTop: !showSelectionToolBar && isVisibleHeader ? "84px" : ''
                            // paddingTop: "84px" //for disable LobbyMenuLine
                        }
                    }

                }

                
                //mapSide == "left" ? ({ flexDirection: 'row', justifyContent: itemsAling }) : ({ flexDirection: 'row-reverse', justifyContent: itemsAling })

                let flagLeftMap = false; // also it's mean that page projects (for markers) 
                let showHeader = pathname.includes('project');
                return (
                    <div onMouseMove={this.handleMouseMove.bind(this)} id="smartluxe" >
                        {
                            isVisibleHeader ? (!selectionHeader ? (
                                <Header
                                width={width}
                                    saveState={this.saveState}
                                    neighboorhoods={neighboorhoods}
                                    dictionary={this.state.dictionary}
                                    pageScroll={this.state.pageScroll}
                                    allowedLanguages={allowedLanguages}
                                    articlesTranslations={articlesTranslations}
                                    disableMenu={headerDisableMenu}
                                    currentPage={currentPage}
                                />
                            ) : (
                                <HeaderSelection
                                    saveState={this.saveState}
                                    width={width}
                                    pageIsLoaded={this.state.pageIsLoaded}
                                    dictionary={dictionary}
                                    selectionId={selectionId}
                                    currentSelectionListing={currentSelectionListing}
                                    agentId={agentId}
                                    currentProjectLogo={currentProjectLogo}
                                    allowedLanguages={allowedLanguages}
                                />
                            )
                            ) : (
                                null
                            )
                        }



                        {!showSelectionToolBar ? (null) : (
                            <ConstructionLobbyMenu
                                applicationHistoryService={this.applicationHistoryService}
                                neighboorhoods={neighboorhoods}
                                projectPage={showHeader}
                                dictionary={dictionary}
                                width={this.state.width}
                                currentSelectionListing={currentSelectionListing}
                                form={constructionLobbySearchForm}
                                handleInputForm={this.handleInputForm}
                            />
                        )}
                        <div className='Selection' style={selectionStyle}>
                            {!pathname.includes('/article') && !pathname.includes('/campaign') &&  !isVisibleSliderModal ? (
                                <SelectionMap
                                    height={height}
                                    dictionary={dictionary}
                                    width={this.state.width}
                                    listings={dataForMap}
                                    currentSelectionListing={currentSelectionListing}
                                    selectionId={selectionId}
                                    agentId={agentId}
                                    listingExpiredList={listingExpiredList}
                                    markersWithModal={!flagLeftMap}
                                    hoveredMarkerId={hoveredMarkerId}
                                    selectionMapFloating={selectionMapFloating}
                                    selectionMapSettings={selectionMapSettings}
                                    saveCurrentSelectionListing={this.saveCurrentSelectionListing}
                                    mapSecondaryMarkers={mapSecondaryMarkers}
                                    mapSoldOutMarkers={mapSoldOutMarkers}
                                    currentPage={currentPage}
                                    displayOnMobile={displayOnMobileSelectionMap}
                                    mapSide={mapSide}
                                />
                            ) : null}
                            <RouterMark 
                                style={routerMarkStyle}
                                width={widthRouterMark}
                                minHeight={heightRouterMark}
                                applicationWidth={width}
                            >
                                <Switch location={location} key={location.pathname}>

                                    <Route path={routeGroups.selection.projectGallery}>
                                        <ScrollBlock>
                                                <StandAloneGalleryPage
                                                    pageScroll={pageScroll}
                                                    mobileVerison={mobileVerison}
                                                    neighborhoods={neighboorhoods}
                                                    dictionary={this.state.dictionary}
                                                    width={this.state.width}
                                                    country={country}
                                                    saveState={this.saveState}
                                                />
                                        </ScrollBlock>
                                    </Route>

                                    

                                    <Route path={routeGroups.selection.projectInner}>
                                        <ScrollBlock>
                                                <ProjectInnerPage
                                                    mouseEvent={mouseEvent}
                                                    mobileVerison={mobileVerison}
                                                    pageScroll={pageScroll}
                                                    widthRouterMark={widthRouterMark}
                                                    hoveredMarkerId={hoveredMarkerId}
                                                    dictionary={this.state.dictionary}
                                                    width={this.state.width}
                                                    saveCurrentSelectionListing={this.saveCurrentSelectionListing}
                                                    saveDataForMap={this.saveDataForMap}
                                                    country={country}
                                                    neighbourhoods={neighboorhoods}
                                                    saveState={this.saveState}
                                                />
                                        </ScrollBlock>
                                    </Route>



                                    <Route path={routeGroups.selection.projects}>
                                        <ScrollBlock>
                                                <ConstructionLobbyPage
                                                    widthRouterMark={widthRouterMark}
                                                    form={constructionLobbySearchForm}
                                                    hoveredMarkerId={hoveredMarkerId}
                                                    dictionary={this.state.dictionary}
                                                    width={this.state.width}
                                                    saveDataForMap={this.saveDataForMap}
                                                    saveCurrentSelectionListing={this.saveCurrentSelectionListing}
                                                    country={country}
                                                    saveState={this.saveState}
                                                />
                                        </ScrollBlock>
                                    </Route>

                                    <Route path={routeGroups.selection.selectionListing}>
                                        <ScrollBlock>
                                                <SelectionListingPage
                                                    widthRouterMark={widthRouterMark}
                                                    dictionary={this.state.dictionary}
                                                    width={this.state.width}
                                                    currentSelectionListing={currentSelectionListing}
                                                    saveCurrentSelectionListing={this.saveCurrentSelectionListing}
                                                    saveSelectionListings={this.saveSelectionListings}
                                                    height={height}
                                                    country={country}
                                                    agentId={agentId}
                                                    setSliderModal={this.setSliderModal}
                                                    saveState={this.saveState}
                                                />
                                        </ScrollBlock>
                                    </Route>

                                    <Route path={routeGroups.selection.selectionOffer}>
                                        <ScrollBlock>
                                                <SelectionProjectOfferPage
                                                    widthRouterMark={widthRouterMark}
                                                    dictionary={this.state.dictionary}
                                                    width={this.state.width}
                                                    height={height}
                                                    agentId={agentId}
                                                    saveState={this.saveState}
                                                    saveSelectionListings={this.saveSelectionListings}
                                                    saveDataForMap={this.saveDataForMap}
                                                />
                                        </ScrollBlock>
                                    </Route>

                                    <Route path={routeGroups.selection.selection}>
                                        <ScrollBlock>
                                                <SelectionPage
                                                    hoveredMarkerId={hoveredMarkerId}
                                                    widthRouterMark={widthRouterMark}
                                                    dictionary={this.state.dictionary}
                                                    width={width}
                                                    agentId={agentId}
                                                    saveCurrentSelectionListing={this.saveCurrentSelectionListing}
                                                    saveSelectionListings={this.saveSelectionListings}
                                                    country={country}
                                                    saveState={this.saveState}
                                                />
                                        </ScrollBlock>
                                    </Route>


                                    

                                </Switch>
                                <SelectionListingModal
                                    dictionary={dictionary}
                                    width={width}
                                    height={height}
                                    isVisible={selectionListingModal}
                                    data={currentSelectionListing}
                                    country={country}
                                    currentSlide={currentSlideSelection}
                                    agent={agent}
                                />
                            </RouterMark>
                        </div>
                        {isVisibleFooter && <Footer
                            dictionary={this.state.dictionary}
                            neighboorhoods={neighboorhoods}
                            currentProjectLogoInvert={currentProjectLogoInvert}
                            hideElems={footerHideElem}
                             currentPage={currentPage}
                             width={width}
                        />}

                    </div>

                )
            }
        } else {
            return null;
        }
    }

    render() {
        this.insertJSONLD();
        return (
            <>
                <AnimatePresence >
                    {this.renderBody()}
                </AnimatePresence>

            </>
        )
    }
}
export default withRouter(SmartLuxe)
